module.exports = __webpack_public_path__ + "img/bubble5-active.a7932c01.svg";